import axiosInstance from "../../features/api/axiosInstance";
const base_url = process.env.REACT_APP_API_URL;

const API_URL = `${base_url}admin/policy-documents`; // Replace "our-service" with your actual endpoint

// ✅ Get all items
const getPolicyDocuments = async () => {

  const response = await axiosInstance.get(API_URL);
  return response.data;
};


// ✅ Create new item
const createPolicyDocument = async (itemData) => {

  const response = await axiosInstance.post(API_URL, itemData);
  return response.data;
};

// ✅ Update existing item
const updatePolicyDocument = async (itemId, itemData) => {

  const response = await axiosInstance.put(
    `${API_URL}/${itemId}`,
    itemData,
  );
  return response.data;
};

// ✅ Delete item
const deletePolicyDocument = async (itemId) => {
  const response = await axiosInstance.delete(`${API_URL}/${itemId}`);
  return response.data;
};

const getPolicyDocumentByUuid = async (uuid) => {
  const response = await axiosInstance.get(`${API_URL}/${uuid}`);
  return response.data;
};

const policyDocument = {
  getPolicyDocuments,
  createPolicyDocument,
  updatePolicyDocument,
  deletePolicyDocument,
  getPolicyDocumentByUuid
};

export default policyDocument;
